import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "insight",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-scheduler" */ "./components"),
        import(
          /* webpackChunkName: "course-scheduler" */ "../YearlyInsight/modules/Module"
        ),
        import(
          /* webpackChunkName: "course-scheduler" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const multiLevelNodeEditorReducer = importedModule2.default;
        injectReducer(store, {
          key: "yearlyInsight",
          reducer,
        });
        injectReducer(store, {
          key: "multiLevelNodeEditor",
          reducer: multiLevelNodeEditorReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
